<template>
  <div class="input-select-field align-items-center justify-content-between text-size-14">
    <div class="text-size-12 " 
    :class="[{'d-flex mr-2': !isMobileView}, aligmentCss]">{{ label }} :</div>
    <v-select
      ref="start"
      v-if="1"
      :options="listOfOptions"
      :appendToBody="false"
      :clearable="true"
      :searchable="false"
      :placeholder="$t('general.select')"
      :reduce="(title) => title.code"
      :value="startTime"
      @input="selectOption"
      @open="onFocus"
      @close="onBlurr"
      label="title"
      :dir="getDirectionOfText"
    ></v-select>
    <!-- :selectable="(title) => selectable != false" -->
  </div>
</template>
<script>
import vSelect from 'vue-select';
import { createPopper } from '@popperjs/core'
// import 'vue2-timepicker/dist/VueTimepicker.css';
import { deviceMixin } from '@/components/mixins/DeviceMixins';

export default {
  name: 'InputSelectField',
  props: ['label', 'value', 'options', 'selectable', 'isCentered' ],
  mixins: [deviceMixin],

  data() {
    return {
      myValue: this.value,
      startTime: null,
      placement: 'top'            
    };
  },

  components: {
    vSelect,
  },

  computed: {

  aligmentCss() {
      if( this.isCentered ) {
        return "justify-content-center"
      }
      return "justify-content-end"      
    },

    listOfOptions() {
      let list = [];

        let code = 0;
        for( let option of this.options) {
        let item = {};
        item.code = code++;
        item.title = option;
        list.push(item);

        }
      return list;
    },
    getDirectionOfText() {
      return this.isMobileView ? 'rtl': 'ltr';
    }
  },

  methods: {
    withPopper(dropdownList, component, { width }) {
      /**
       * We need to explicitly define the dropdown width since
       * it is usually inherited from the parent with CSS.
       */
      dropdownList.style.width = width;

      /**
       * Here we position the dropdownList relative to the $refs.toggle Element.
       *
       * The 'offset' modifier aligns the dropdown so that the $refs.toggle and
       * the dropdownList overlap by 1 pixel.
       *
       * The 'toggleClass' modifier adds a 'drop-up' class to the Vue Select
       * wrapper so that we can set some styles for when the dropdown is placed
       * above.
       */

      console.log("createPopper:", this.placement);
      const popper = createPopper(component.$refs.toggle, dropdownList, {
        placement: this.placement,
        modifiers: [
          {
            name: 'offset',
            options: {
              offset: [0, -32],
            },
          },
          {
            name: 'toggleClass',
            enabled: true,
            phase: 'write',
            fn({ state }) {
              component.$el.classList.toggle(
                'drop-up',
                state.placement === 'top'
              );
            },
          },
        ],
      });

      /**
       * To prevent memory leaks Popper needs to be destroyed.
       * If you return function, it will be called just before dropdown is removed from DOM.
       */
      return () => popper.destroy();
    },


    selectOption(value) {
      let tap = this.$refs.start.typeAheadPointer;
      const text  = this.options[value];
      console.info('setSelection value:', text);
      this.startTime = text;
      this.$nextTick(() => {
        this.$refs.start.typeAheadPointer = tap;
      });
      this.$emit('select', value);
    },

    clearStartDate() {
    
    },

    onFocus() {
      console.log('OnFocus');
      //this.$emit('focus');
    },

    onBlurr() {
      this.$emit('blurr');
    },

    changeHandler(eventData) {
      console.log(eventData);
    },
  },

  mounted() {

    const index = this.value;
    const text  = this.options[index];
    console.info('setSelection value:', text);
    this.startTime = text;
    this.$nextTick(() => {
      this.$refs.start.typeAheadPointer = index;
    });
  },
};

import '@/styles/select-variables.scss';
</script>

<style lang="scss">
@import '@/styles/colors.scss';

.choice-info {
  display: flex;
  white-space: nowrap;
  font-size: 14px;
  overflow-y: visible;
  width: 100%;
  box-sizing: border-box;    
}

.v-select {
  margin-top: 0px;
  background-color: $white;
  width: 100%;
  box-sizing: border-box;  
}




.vs__dropdown-menu {
  position: relative !important;  
  z-index: 42000 !important;  
}


.vs__dropdown-option {
  position: relative !important;  
  z-index: 42000 !important;  
  font-size: 14px;
}


.vs__search {
  padding-left: 7px;
  box-sizing: border-box;
}


// .v-select.drop-up.vs--open .vs__dropdown-toggle {
//   border-radius: 0 0 4px 4px;
//   border-top-color: transparent;
//   border-bottom-color: rgba(60, 60, 60, 0.26);
// }

// [data-popper-placement='top'] {
//   border-radius: 4px 4px 0 0;
//   border-top-style: solid;
//   border-bottom-style: none;
//   box-shadow: 0 -3px 6px rgba(0, 0, 0, 0.15);
// }



@media (max-width: 767px) {
  .v-select {
    width: 100%;
    border-radius: 4px;
  }
}

button.vs__clear {
  line-height: 18px !important;
}

.vs__selected-options {
  min-width: 80px;
  text-align: center;
}

.input-select-field {
  overflow-x: hidden;
}
</style>
